import { useEffect, useRef, useState } from "react";
import { FolderPlus, UserPlus2, Zap, Rocket } from "lucide-react";
import { motion } from "motion/react";
import "../OnBoard/Onboard.css";
import { Link, useNavigate } from "react-router-dom";
import freePlanClient from "../config/freePlanClient";
import { useData } from "./DaysContext";
// D:\Simplifyte\Website-www.simplifyte.com\src\OnBoard\Onboard.css
const onboardingSteps = [
  {
    icon: FolderPlus,
    number: "01",
    title: "Create your workspace",
    description:
      "Set up your team structure, projects, and workflows in minutes",
  },
  {
    icon: UserPlus2,
    number: "02",
    title: "Invite your team",
    description: "Add team members with role-based access and permissions",
  },
  {
    icon: Zap,
    number: "03",
    title: "Start closing work",
    description:
      "Begin managing tasks, approvals, and deliverables from day one",
  },
];
export default function Onboard() {
  const { days, loading } = useData();

  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.15 },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="Onboarding_Section">
      <div className="Onboarding_Background">
        <motion.div className="Onboarding_BackgroundGlow" />
      </div>

      <div className="Onboarding_Container">
        <motion.div className="Onboarding_Header">
          <div className="Onboarding_Badge">
            <Rocket className="Onboarding_BadgeIcon" />
            <span className="Onboarding_text">GETTING STARTED</span>
          </div>

          <h2 className="Onboarding_Title">
            Start Fast,{" "}
            <span className="Onboarding_TitleHighlight">Scale Smoothly</span>
          </h2>

          <p className="Onboarding_Description">
            Set up your workspace, invite your team, and begin managing work
            with absolute clarity from day one.
          </p>
        </motion.div>

        {/* Steps */}
        <div className="Onboarding_StepsGrid">
          {onboardingSteps.map((step, index) => (
            <div key={step.number} className="Onboarding_StepCard">
              <div className="Onboarding_IconWrapper">
                <step.icon className="Onboarding_StepIcon" strokeWidth={1.5} />
                <div className="Onboarding_StepNumber">{step.number}</div>
              </div>

              <h3 className="Onboarding_StepTitle">{step.title}</h3>

              <p className="Onboarding_StepDescription">{step.description}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="Onboarding_CTA">
          <button className="Onboarding_ButtonPrimary">
            <Link to="https://app.simplifyte.com/login">
              Get Started for Free
            </Link>
          </button>

          <button
            className="Onboarding_ButtonSecondary"
            onClick={() => navigate("/contactsales")}
          >
            Request a Demo
          </button>
        </div>
        <div>
          <p className="Onboarding_TrialText">
            <span>No credit card required</span>
            <span className="Onboarding_Dot"></span>
            <span>{loading ? "..." : days || 14} - day free trial</span>
            <span className="Onboarding_Dot"></span>
            <span>Cancel anytime</span>
          </p>
        </div>
      </div>
    </section>
  );
}
